<div class="main-container">
  <!-- Header Section -->
  <div class="page-header">
    <div class="routing-buttons">
      <div
        class="action-button back-button"
        (click)="navigateBack()"
        tabindex="0"
        (keydown.enter)="navigateBack()"
      >
        <mat-icon class="icon back-icon">arrow_back</mat-icon>
      </div>
      <div
        class="action-button reload-button"
        (click)="ngOnInit()"
        tabindex="0"
        (keydown.enter)="ngOnInit()"
      >
        <mat-icon class="icon reload-icon">refresh</mat-icon>
      </div>
      <span class="page-title"> Create New Device OTA Batch </span>
    </div>
    <div class="button-group">
      <app-ota-info></app-ota-info>
    </div>
  </div>

  <form [formGroup]="ParametersListForm" novalidate>
    <!-- Ota Batch Details Section -->
    <div class="component-container">
      <div class="component-header">
        <h6 class="component-title">OTA Batch Details</h6>
        <div class="component-actions">
          @if (otaType === 'bulk') {
            <button
              class="primary-button"
              (click)="downloadMyFile()"
              type="button"
            >
              Download Sample OTA Template
              <mat-icon class="btn-icon">download</mat-icon>
            </button>
          }
          @if (otaType === 'custom') {
            <button
              class="primary-button"
              (click)="downloadMyFile()"
              type="button"
            >
              Download Custom OTA Template
              <mat-icon class="btn-icon">download</mat-icon>
            </button>
          }
        </div>
      </div>
      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>

      <!-- Component Body Section -->
      <div class="component-body">
        <div class="form-section">
          <!-- Batch Name -->
          <div class="form-group">
            <label for="name" class="form-label">Batch Name</label>
            <mat-form-field appearance="outline">
              <mat-label>Batch Name</mat-label>
              <input
                matInput
                formControlName="name"
                placeholder="Batch Name"
                required
              />
              @if (
                ParametersListForm.controls['name'].touched &&
                ParametersListForm.controls['name'].errors
                  ?.requiredAndNoEmptySpaces
              ) {
                <mat-error>
                  {{
                    ParametersListForm.controls['name'].errors
                      ?.requiredAndNoEmptySpaces
                  }}
                </mat-error>
              }
            </mat-form-field>
          </div>
          <!-- Batch Description -->
          <div class="form-group">
            <label for="description" class="form-label"
              >Batch Description</label
            >
            <mat-form-field appearance="outline">
              <mat-label>Batch Description</mat-label>
              <input
                matInput
                placeholder="Batch Description"
                formControlName="description"
                required
              />
              @if (
                ParametersListForm.controls['description'].touched &&
                ParametersListForm.controls['description'].errors
                  ?.requiredAndNoEmptySpaces
              ) {
                <mat-error>
                  {{
                    ParametersListForm.controls['description'].errors
                      ?.requiredAndNoEmptySpaces
                  }}
                </mat-error>
              }
            </mat-form-field>
          </div>
          <!-- Batch Type -->
          <div class="form-group">
            <label for="otaType" class="form-label">Batch Type</label>
            <mat-form-field appearance="outline">
              <mat-label>Batch Type</mat-label>
              <mat-select
                (selectionChange)="setOtaBatchType()"
                formControlName="otaType"
                required
              >
                <mat-option value="manual">Manual OTA</mat-option>
                <mat-option value="bulk">Bulk OTA</mat-option>
                <mat-option value="custom">Custom OTA</mat-option>
              </mat-select>
            </mat-form-field>
            @if (
              ParametersListForm.controls['otaType'].touched &&
              ParametersListForm.controls['otaType'].errors?.required
            ) {
              <mat-error> This field is Mandatory. </mat-error>
            }
          </div>

          @if (otaType === 'custom') {
            <div class="form-group">
              <label for="otaCommand" class="form-label"
                >Select OTA Batch Command</label
              >
              <mat-form-field appearance="outline">
                <mat-label>Select OTA Batch Command</mat-label>
                <mat-select
                  #otaSelect
                  formControlName="otaCommand"
                  (selectionChange)="onCommandSelect($event.value)"
                >
                  @if (otaSelect.focused) {
                    <mat-option>
                      <ngx-mat-select-search
                        placeholderLabel="Search OTA Commands"
                        [formControl]="otaCommandFilterCtrl"
                        [noEntriesFoundLabel]="'No matching command found'"
                        (filteredReturn)="(filteredSetCommandList)"
                      >
                      </ngx-mat-select-search>
                    </mat-option>
                  }

                  @for (cmd of filteredSetCommandList; track cmd) {
                    <mat-option [value]="cmd">
                      {{ cmd.otaCommand }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>

              @if (
                ParametersListForm.controls['otaCommand'].touched &&
                ParametersListForm.controls['otaCommand'].errors?.['required']
              ) {
                <mat-error>This field is Mandatory.</mat-error>
              }
            </div>
          }

          <!-- Upload File -->
          @if (otaType === 'bulk' || otaType === 'custom') {
            <div class="form-group">
              <label for="fileName" class="form-label">Upload File</label>
              <mat-form-field
                class="file-upload-container"
                appearance="outline"
              >
                <mat-label>Upload File</mat-label>

                <!-- Display File Name or Placeholder -->
                <input
                  matInput
                  type="text"
                  formControlName="fileName"
                  [value]="ParametersListForm.controls['fileName'].value"
                  readonly
                />

                <!-- Hidden File Input -->
                <input
                  type="file"
                  accept=".csv"
                  aria-label="File"
                  class="d-none"
                  (change)="onFileChange($event)"
                  #fileInput
                />

                <!-- Custom Upload Button -->
                <button
                  mat-button
                  class="upload-btn"
                  (click)="fileInput.click()"
                  type="button"
                  matTooltip="Batch cannot be created for more than 20,000 devices."
                >
                  <mat-icon>attach_file</mat-icon>
                </button>

                <!-- Error Message -->
                @if (
                  ParametersListForm.controls['fileName'].touched &&
                  ParametersListForm.controls['fileName'].errors?.required
                ) {
                  <mat-error> This field is Mandatory. </mat-error>
                }
              </mat-form-field>
            </div>
          }
        </div>
      </div>
      @if (otaType === 'custom') {
        <div class="component-footer">
          <div class="button-group">
            <button
              (click)="submitCustomOta()"
              type="button"
              class="submit-button"
              [disabled]="ParametersListForm.invalid"
            >
              Submit Batch<mat-icon class="btn-icon">check_circle</mat-icon>
            </button>
          </div>
        </div>
      }
    </div>

    <!-- Manual: Device List -->
    @if (otaType === 'manual') {
      <div class="component-container">
        <div class="component-header">
          <h6 class="component-title">Device List</h6>
          <div class="component-actions">
            <app-common-search
              [initialSearchValue]="
                ParametersListForm?.get('searchDevice')?.value
              "
              (searchSubmit)="onSearch($event)"
            ></app-common-search>
          </div>
        </div>
        <!-- Separator between Header and Body -->
        <div class="component-separator"></div>

        <!-- Component Body Section -->
        <div class="component-body">
          <table>
            <thead>
              <tr>
                <th></th>
                <th>UIN</th>
                <th>ICCID</th>
                <th>IMEI</th>
                <th>Device Model</th>
              </tr>
            </thead>
            @if (sampleData.length !== 0) {
              <tbody>
                @for (
                  deviceValue of sampleData
                    | paginate
                      : {
                          id: 'paginate',
                          itemsPerPage: size2,
                          currentPage: page2,
                          totalItems: totalCount,
                        };
                  track deviceValue
                ) {
                  <tr>
                    <td>
                      <input
                        type="checkbox"
                        [checked]="deviceValue.isAssigned"
                        value=""
                        [id]="'flexCheckDefault' + deviceValue.uid"
                        (change)="onViewChange($event, deviceValue)"
                      />
                    </td>
                    <td>
                      <label
                        [for]="'flexCheckDefault' + deviceValue.uid"
                        style="cursor: pointer"
                      >
                        {{ deviceValue.uid }}
                      </label>
                    </td>
                    <td>
                      <label
                        [for]="'flexCheckDefault' + deviceValue.uid"
                        style="cursor: pointer"
                      >
                        {{ deviceValue.iccid }}
                      </label>
                    </td>
                    <td>
                      <label
                        [for]="'flexCheckDefault' + deviceValue.uid"
                        style="cursor: pointer"
                      >
                        {{ deviceValue.imei }}
                      </label>
                    </td>
                    <td>
                      <label
                        [for]="'flexCheckDefault' + deviceValue.uid"
                        style="cursor: pointer"
                      >
                        {{ deviceValue.modelName }}
                      </label>
                    </td>
                  </tr>
                }
              </tbody>
            }
            @if (sampleData.length === 0) {
              <tbody>
                <tr>
                  <td colspan="7">
                    <img
                      class="no-data-img"
                      src="../../assets/dataNotFound.jpg"
                      alt="No Data Found"
                    />
                  </td>
                </tr>
              </tbody>
            }
          </table>
        </div>
        <div class="component-separator"></div>
        <div class="component-footer">
          @if (sampleData.length > 0) {
            <app-common-component-pagination
              [totalItems]="totalCount"
              [pageSize]="size"
              [currentPage]="page"
              (pageChange)="onPageChange($event)"
              (sizeChange)="onSizeChange($event)"
            >
            </app-common-component-pagination>
          }
        </div>
      </div>
    }

    <!-- OTA Command List -->
    @if (
      (deviceArray.length > 0 && otaType !== 'custom') ||
      (otaType === 'bulk' && isFileUploaded)
    ) {
      <div class="component-container">
        <div class="component-header">
          <h6 class="component-title">OTA Command List</h6>
          <div class="component-actions">
            <app-common-component-dropdown-search
              [items]="otaOverviewFilter"
              [initialValue]="filterForm?.get('filterSelected')?.value"
              [placeHolder]="'Select OTA Type'"
              (itemSelected)="filterSelected($event)"
            ></app-common-component-dropdown-search>
            <app-common-search
              [initialSearchValue]="
                ParametersListForm?.get('searchDevice')?.value
              "
              (searchSubmit)="onSearchOtaCommandList($event)"
            ></app-common-search>
          </div>
        </div>
        <!-- Separator between Header and Body -->
        <div class="component-separator"></div>

        <!-- Component Body Section -->
        <div class="component-body">
          @if (commandArray.length > 0) {
            <div class="ota-form-section">
              @for (item of commandArray; track item) {
                <div class="border">
                  <mat-checkbox
                    class="full-width-checkbox"
                    (change)="addToCheckedArray($event, item)"
                    [checked]="checkChecked(item)"
                    [id]="'flexCheckDefault' + item.name"
                  >
                    {{ item.name }}
                  </mat-checkbox>
                </div>
              }
            </div>
          } @else {
            <table>
              <tr>
                <td>
                  <img
                    class="no-data-img"
                    src="../../assets/dataNotFound.jpg"
                    alt="No Data Found"
                  />
                </td>
              </tr>
            </table>
          }
        </div>
        <div class="component-separator"></div>
        <div class="component-footer">
          <div class="button-group">
            <button
              class="edit-button"
              type="button"
              (click)="toggleSelectAll()"
            >
              {{ allSelected ? 'Deselect All' : 'Select All' }}
              <mat-icon class="btn-icon">{{
                allSelected ? 'check_box_outline_blank' : 'check_box'
              }}</mat-icon>
            </button>
            @if (
              deviceArray.length > 0 || (otaType === 'bulk' && isFileUploaded)
            ) {
              <button
                type="button"
                (click)="SubmitCommandArray()"
                class="submit-button"
                [disabled]="checkedArr.length === 0"
              >
                Set Batch<mat-icon class="btn-icon">check_circle</mat-icon>
              </button>
            }
          </div>
        </div>
      </div>
    }
    @if (config && checkedArr.length > 0) {
      <div class="component-container">
        <div class="component-header">
          <h6 class="component-title">Set Configuration Value</h6>
        </div>
        <!-- Separator between Header and Body -->
        <div class="component-separator"></div>

        <!-- Component Body Section -->
        <div class="component-body">
          <form [formGroup]="CommandForm">
            <table>
              <tr>
                <th>OTA Command Name</th>
                <th>OTA Command to be Triggered</th>
                <th>Example</th>
                <th>Input Value</th>
                <th>Action</th>
              </tr>
              <tbody>
                @for (
                  item of otaListSelected
                    | paginate
                      : {
                          id: 'para_pagination',
                          itemsPerPage: size,
                          currentPage: page,
                          totalItems: totalLength,
                        };
                  track item
                ) {
                  <tr>
                    <td>
                      {{ item.name }}
                    </td>
                    <td>
                      {{ item.otaCommand }}
                    </td>
                    <td>
                      {{ item.example }}
                    </td>
                    <td>
                      <div class="form-group">
                        <mat-form-field appearance="outline">
                          <mat-label>Input Value</mat-label>
                          <input
                            matInput
                            type="text"
                            placeholder="Please Enter Input Value"
                            aria-label="OTA Command name"
                            formControlName="{{ item.otaCommand }}"
                          />
                          @if (
                            CommandForm.controls[item.otaCommand].touched &&
                            CommandForm.controls[item.otaCommand].errors
                              ?.requiredAndNoEmptySpaces
                          ) {
                            <mat-error>
                              {{
                                CommandForm.controls[item.otaCommand].errors
                                  ?.requiredAndNoEmptySpaces
                              }}
                            </mat-error>
                          }
                        </mat-form-field>
                      </div>
                    </td>
                    <td>
                      <div class="action-buttons">
                        <button
                          class="primary-button delete-button"
                          type="button"
                          (click)="deleteCommand(item.id)"
                        >
                          <mat-icon class="btn-icon"> delete </mat-icon>
                        </button>
                        <button
                          class="primary-button export-button"
                          type="button"
                          (click)="clearCommand(item.otaCommand)"
                        >
                          <mat-icon class="btn-icon"> backspace </mat-icon>
                        </button>
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </form>
        </div>
        <div class="component-separator"></div>
        <div class="component-footer">
          <app-common-component-pagination
            [totalItems]="totalLength"
            [pageSize]="size"
            [currentPage]="page"
            (pageChange)="changePage($event)"
            (sizeChange)="changeSize($event)"
          >
          </app-common-component-pagination>
        </div>

        <div class="component-separator"></div>

        <div class="component-footer">
          <div class="button-group">
            <button
              (click)="submit()"
              type="button"
              class="submit-button"
              [disabled]="CommandForm.invalid"
            >
              Submit Batch<mat-icon class="btn-icon">check_circle</mat-icon>
            </button>
          </div>
        </div>
      </div>
    }
  </form>
</div>
